import { del, get, patch, post } from './client'

/** scope 目录：new-api v1.0.0 的访问令牌按权限签发，scope 形如 `resource:action` */
export interface AccessTokenCatalogAction {
  action: string
  label_key?: string
  description_key?: string
}

export interface AccessTokenCatalogResource {
  resource: string
  label_key?: string
  actions?: AccessTokenCatalogAction[]
}

export interface AccessTokenCatalogGroup {
  group: string
  resources: AccessTokenCatalogResource[]
}

export interface AccessTokenCatalog {
  groups: AccessTokenCatalogGroup[]
  max_tokens?: number
  default_expiry_days?: number
}

export interface AccessTokenItem {
  id: number
  name: string
  scopes?: string[]
  expires_at?: number
  last_used_at?: number
  created_at?: number
}

const withProof = (proof?: string) =>
  proof ? { headers: { 'X-Security-Proof': proof } } : undefined

/** GET /api/user/access_tokens/catalog */
export async function getAccessTokenCatalogApi(): Promise<AccessTokenCatalog> {
  return get('/api/user/access_tokens/catalog')
}

/** GET /api/user/access_tokens */
export async function listAccessTokensApi(): Promise<AccessTokenItem[]> {
  return get('/api/user/access_tokens')
}

/**
 * POST /api/user/access_tokens
 * 需要 access_token.generate 的凭据，且凭据绑定 scopes + expires_at。
 */
export async function createAccessTokenApi(
  data: { name: string; scopes: string[]; expires_at: number },
  proof?: string
): Promise<{ token: string; item: AccessTokenItem }> {
  return post('/api/user/access_tokens', data, withProof(proof))
}

/** PATCH /api/user/access_tokens/:id（仅改名） */
export async function renameAccessTokenApi(id: number, name: string): Promise<void> {
  return patch(`/api/user/access_tokens/${id}`, { name })
}

/** DELETE /api/user/access_tokens/:id */
export async function deleteAccessTokenApi(id: number, proof?: string): Promise<void> {
  return del(`/api/user/access_tokens/${id}`, withProof(proof))
}

/** scope 字符串拼接，与后端 `resource + ":" + action` 一致 */
export const accessTokenScope = (resource: string, action: string) => `${resource}:${action}`
